var _path, _path2, _ellipse, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentOtpStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1447 14.9468V9C44.1447 7.34314 42.8015 6 41.1447 6H11C9.34315 6 8 7.34315 8 9V63.8382C8 65.4951 9.34315 66.8382 11 66.8382H26.0723",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6055 19.9491H64.5984C66.2553 19.9491 67.5984 21.2922 67.5984 22.9491V81C67.5984 82.6569 66.2553 84 64.5984 84H32.6055C30.9486 84 29.6055 82.6569 29.6055 81V22.9491C29.6055 21.2922 30.9486 19.9491 32.6055 19.9491Z",
    fill: "#F2CA00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6017,
    cy: 70.2748,
    rx: 3.59393,
    ry: 3.55838,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7812 38.4492L67.4798 55.9999L67.4798 45.6042L59.1322 39.4497L81.7812 38.4492Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.876H63",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 52.876H59",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentOtpStatus);
export default __webpack_public_path__ + "static/media/sentOtpStatus.de7097ada7b8bd2a5d21bfa46b7b0480.svg";
export { ForwardRef as ReactComponent };